<template>
  <v-layout row wrap class="ch-search-filter-wrapper">
    <v-flex xs12 class="ch-search-filter pb-0 pt-0">
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-container fluid grid-list-lg class="pt-0 pb-0">
          <v-layout row wrap class="filter-wrap">
            <button class="form-clear-btn" @click.prevent="clearAllField">
              <i class="fas fa-eraser"></i>
              <span>CLEAR</span>
            </button>
            <v-flex xs2 class="pl-0 pr-0" v-if="visibleDomain">
              <v-select
                :items="filterDomainItems"
                v-model="filterDomainInput"
                label="Domain"
                bottom
                @focus.native="getDomainList"
                @click.native="getDomainList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs2 class="pl-0 pr-0">
              <v-select
                :items="filterHotelItems"
                v-model="filterHotelInput"
                label="Name"
                bottom
                @focus.native="getHotelList"
                @click.native="getHotelList"
                autocomplete
                single-line
                hide-details
                clearable
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { hotelsEventBus } from '@/components/admin/hotels/hotelsEventBus';
  import api from '../../../api';

  export default {
    props: ['storeFilter'],
    data() {
      return {
        // NOTE: 모든 검색어
        allSearch: {
          hotel: {
            search: null,
            searchCategory: 'name',
          },
          domain_name: {
            search: null,
            searchCategory: 'domain_id',
          },
        },
        valid: true,
        // NOTE: 렌더링 될 변수들
        visibleDomain: false,
        filterHotel: null,
        filterHotelItems: [],
        filterDomainItems: [],
        filterDomain: null,
      };
    },
    methods: {
      /**
       * @description 상세 => 목록으로 넘어올 경우 필터값을 유지, 컴포넌트가 렌더링될 때 최초 한번만 실행
       */
      init() {
        if (!_.isEmpty(this.storeFilter)) {
          console.log('this.storeFilter not empty');
          const filter = Object.values(this.storeFilter).filter(item => item.search !== null);
          const arr = Object.keys(this.allSearch);
          for (let i = 0; i < arr.length; i += 1) {
            for (let j = 0; j < filter.length; j += 1) {
              if (this.allSearch[arr[i]].searchCategory === filter[j].searchCategory) {
                this.allSearch[arr[i]].search = filter[j].search;
                switch (this.allSearch[arr[i]].searchCategory) {
                  case 'name':
                    this.filterHotel = filter[j].search;
                    this.getHotelList();
                    break;
                  case 'domain_id':
                    this.filterDomain = filter[j].search;
                    this.getDomainList();
                    break;
                  default:
                    break;
                }
              }
            }
          }
          this.$nextTick(() => {
            console.log('this.$nextTick');
            hotelsEventBus.$emit('initFilter', this.allSearch);
          });
        }
      },
      clearAllField() {
        this.$refs.form.reset();
      },
      getHotelList() {
        const query = {
          limit: 1000,
        };
        api.getHotelList(query)
        .then((result) => {
          if (result.status === 200) {
            this.filterHotelItems = result.data.map(obj => obj.name);
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      getDomainList() {
        api.getDomainList()
        .then((result) => {
          if (result.status === 200) {
            this.filterDomainItems = result.data.map((obj) => {
              const newObj = {};
              newObj.value = obj.id;
              newObj.text = obj.name;
              return newObj;
            });
          }
        })
        .catch((err) => {
          this.alert.type = 'error';
          this.alert.color = 'red';
          this.alert.message = err.response.data.message;
          this.alertOccur();
        });
      },
      /**
       * @description 사용자가 입력을 기다리는 시간(밀리세컨드) 입니다.
       * @param { Object } object, this.allSearch
       */
      getInputValue: _.debounce((obj) => {
        hotelsEventBus.$emit('customFilter', obj);
        storeFilterEventBus.$emit('setFilter', obj);
      }, 100),
    },
    computed: {
      filterHotelInput: {
        get() {
          return this.filterHotel;
        },
        set(newValue) {
          this.filterHotel = newValue;
          this.allSearch.hotel.search = newValue;
          hotelsEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
      filterDomainInput: {
        get() {
          return this.filterDomain;
        },
        set(newValue) {
          this.filterDomain = newValue;
          this.allSearch.domain_name.search = newValue;
          hotelsEventBus.$emit('customFilter', this.allSearch);
          storeFilterEventBus.$emit('setFilter', this.allSearch);
        },
      },
    },
    mounted() {
      this.init();
    },
    created() {
      this.visibleDomain = localStorage.getItem('domain_type') === 'root';
    },
    beforeDestroy() {
      hotelsEventBus.$off('initFilter');
      hotelsEventBus.$off('customFilter');
    },
  };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/hotels/HotelsFilter.vue